// frontend/src/service/authHelper.ts
import axiosInstance from "../configuration/api";
import { UserRole } from "../enums/userEnums";

export interface AuthResponse {
  message: string;
  token: string;
  user: {
    _id: string;
    name: string;
    emailAddress: string;
    role: UserRole;
    picture?: string;
    contactNumber: number;
  };
}

export const signup = async (userData: any): Promise<AuthResponse> => {
  try {
    const response = await axiosInstance.post("/api/v1/user/signup", userData);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Signup failed");
  }
};

export const googleAuth = () => {
  localStorage.removeItem("authData");
  window.location.href = `${process.env.REACT_APP_API_HOST}/api/v1/user/google`;
};

export const verifyAuth = async (): Promise<boolean> => {
  const { token } = JSON.parse(localStorage.getItem("authData") || "");
  if (!token) {
    return false;
  }

  try {
    const response = await axiosInstance.get("/api/v1/user/protected", {
      _skipAuthRefresh: true,
    });

    return response.status === 200;
  } catch (error) {
    console.error("Auth verification error:", error);
    return false;
  }
};
